import { LogNavigationButtons } from 'src/components'

import { ROUTES } from 'src/constants'

const buttons = [
  { label: 'change-logs-header-title.v', route: ROUTES.CHANGES },
  { label: 'users-sessions-header-title.v', route: ROUTES.USER_SESSIONS },
  { label: 'error-logs-header-title.v', route: ROUTES.ERROR_LOGS },
  { label: 'transaction-logs-nav-title.v', route: ROUTES.TRANSACTION_LOGS },
]

const NavigationButtons = () => {
  return <LogNavigationButtons items={buttons} />
}

export { NavigationButtons }
